// Utility for managing localStorage with year-based keys
// This prevents data contamination between different chili cookoff events

const getCurrentYear = () => {
  const year = new Date().getFullYear();
  console.log('getCurrentYear called: ', year);
  return year;
};

// Get year-specific localStorage key
const getYearKey = (baseKey) => {
  return `${baseKey}_${getCurrentYear()}`;
};

export const storageUtils = {
  // Set completed items for current year
  setCompletedItems: (items) => {
    const yearKey = getYearKey('completedItems');
    localStorage.setItem(yearKey, JSON.stringify(items));
  },

  // Get completed items for current year
  getCompletedItems: () => {
    const yearKey = getYearKey('completedItems');
    const items = localStorage.getItem(yearKey);
    return items ? JSON.parse(items) : [];
  },

  // Add single item to completed items
  addCompletedItem: (itemId) => {
    const currentItems = storageUtils.getCompletedItems();

    // Avoid duplicates
    if (!currentItems.includes(itemId)) {
      const updatedItems = [...currentItems, itemId];
      storageUtils.setCompletedItems(updatedItems);
      return updatedItems;
    }

    return currentItems;
  },

  // Clear completed items for current year
  clearCompletedItems: () => {
    const yearKey = getYearKey('completedItems');
    localStorage.removeItem(yearKey);
    localStorage.removeItem(getYearKey('additionalGroups'));

    const assignedGroup = localStorage.getItem(getYearKey('group'));
    if (assignedGroup) {
      localStorage.setItem(getYearKey('activeGroup'), assignedGroup);
    } else {
      localStorage.removeItem(getYearKey('activeGroup'));
    }
  },

  // User management (these don't need year-based keys)
  setUser: (email) => {
    localStorage.setItem('user', email);
  },

  getUser: () => {
    return localStorage.getItem('user');
  },

  setUserName: (name) => {
    localStorage.setItem('userName', name);
  },

  getUserName: () => {
    return localStorage.getItem('userName');
  },

  clearUser: () => {
    localStorage.removeItem('user');
    localStorage.removeItem('userName');
    localStorage.removeItem(getYearKey('group'));
    localStorage.removeItem(getYearKey('activeGroup'));
    localStorage.removeItem(getYearKey('additionalGroups'));
  },

  // Tasting group assigned on the Find My Group page
  setGroup: (group) => {
    localStorage.setItem(getYearKey('group'), group);
    localStorage.setItem(getYearKey('activeGroup'), group);
  },

  getGroup: () => {
    return localStorage.getItem(getYearKey('group'));
  },

  // The group currently being tasted. This can differ from the original
  // assignment after the taster chooses to rate more chilis.
  setActiveGroup: (group) => {
    localStorage.setItem(getYearKey('activeGroup'), group);
  },

  getActiveGroup: () => {
    return (
      localStorage.getItem(getYearKey('activeGroup')) ||
      storageUtils.getGroup()
    );
  },

  getAdditionalGroups: () => {
    const groups = localStorage.getItem(getYearKey('additionalGroups'));
    return groups ? JSON.parse(groups) : [];
  },

  addAdditionalGroup: (group) => {
    const groups = storageUtils.getAdditionalGroups();
    if (!groups.includes(group)) {
      localStorage.setItem(
        getYearKey('additionalGroups'),
        JSON.stringify([...groups, group])
      );
    }
  },

  hasGroupAccess: (group) => {
    return (
      storageUtils.getGroup() === group ||
      storageUtils.getAdditionalGroups().includes(group)
    );
  },

  // Debug helper - see all years of data
  getAllYearData: () => {
    const allData = {};
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith('completedItems_')) {
        const data = localStorage.getItem(key);
        if (data) {
          allData[key] = JSON.parse(data);
        }
      }
    }
    return allData;
  },

  // Get current year for display
  getCurrentYear,
};
